import parse from 'url-parse'

export function rewriteEbookUrl (url) {
  const locationInfo = parse(window.location, true)

  const query = locationInfo.query
  const windowHost = locationInfo.hostname

  if (query.itemid !== undefined) {
    const hostname = parse(url, true).hostname
    if (
      (windowHost === 'learningcurve.macmillanlearning.com' ||
      windowHost === 'lcrp.macmillanlearning.com' ||
      windowHost === 'lcrp.macmillantech.com' ||
      windowHost === 'learningcurve.macmillantech.com' ||
      windowHost === 'learningcurve-integration.mldev.cloud' ||
      windowHost === 'learningcurve-hs.bfwpub.com') &&
      url.includes('ebooks')
    ) {
      // prod
      let rewriteHost = 'ebooks.macmillanlearning.com'

      if (windowHost === 'learningcurve.macmillantech.com' ||
        windowHost === 'lcrp.macmillantech.com') {
        rewriteHost = 'ebooks.macmillantech.com'
      } else if (windowHost === 'learningcurve-integration.mldev.cloud') {
        rewriteHost = 'ebooks.mldev.cloud'
      } else if (windowHost === 'learningcurve-hs.bfwpub.com') {
        rewriteHost = 'ebooks-hs.bfwpub.com'
      }

      url = url.replace(hostname, rewriteHost)
    } else {
      // non prod
      if (
        windowHost === 'localhost' ||
        windowHost === 'local-achieve-learningcurve.mldev.cloud'
      ) {
        // localhost
        url = url.replace('https://', 'http://')
        url = url.replace(hostname, 'local-achieve-reading.macmillan.cloud:4000')
      } else if (/\.mldev\.cloud$/.test(windowHost)) {
        // lower tier
        url = url.replace(hostname, windowHost.replace('learningcurve', 'reading'))
      } else if (/\.mml\.cloud$/.test(windowHost)) {
        // int environment - lower tier mml.cloud domains
        url = url.replace(hostname, windowHost.replace('learningcurve', 'reading'))
      }
    }
    url = url + '&resourceId=' + query.itemid
  } else if (url.includes('http://')) {
    // needed to prevent mixed content errors within Courseware or SaplingPlus
    url = url.replace('http://', 'https://')
  }

  return url
}
